import Homepage from "./home/index";
import DocumentPage from "./document/index";
import RewardPage from "./reward/index";
import LegalityPage from "./legality/index";
import VisionPage from "./vision/index";
import CenterPage from "./center/index";
import CurriculumPage from "./curriculum/index";
import InfoPage from "./info/index";
import TeacherPage from "./teacher/index";
import { Routes, Route } from "react-router-dom";
import PrivacyPage from "./privacy";
import TermsPage from "./terms";
function App() {
  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/document" element={<DocumentPage />} />
      <Route path="/reward" element={<RewardPage />} />
      <Route path="/center" element={<CenterPage />} />
      <Route path="/news" element={<InfoPage />} />
      <Route path="/legality" element={<LegalityPage />} />
      <Route path="/vision" element={<VisionPage />} />

      <Route path="/curriculum" element={<CurriculumPage />} />
      <Route path="/teacher" element={<TeacherPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
    </Routes>
  );
}

export default App;
